import { InjectionToken } from '@angular/core';
import { AuthConfig } from '../types/auth.types';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
